import { getRoute } from "@utils/route";

export const CANCELLATION_AND_REFUND_PAGE_URL = '/cancellation-and-refund';

export const routeCancellationAndRefundPage = () => getRoute(CANCELLATION_AND_REFUND_PAGE_URL);
